import { useMemo } from 'react';
import Cookies from 'js-cookie';
import useSWR from 'swr';
import {
    APIGetCurrentFuelPrices,
    APIGetActiveEvTariffs,
} from '../../../config/restAPI/FetchAPI';
import { buildRegistryFuelTariffState } from './registryFuelTariffOptions';

const fuelFetcher = ([, token, agencyId]) => APIGetCurrentFuelPrices(token, agencyId);
const evFetcher = ([, token, agencyId]) => APIGetActiveEvTariffs(token, agencyId);

export const useRegistryFuelTariffOptions = () => {
    const token = Cookies.get('jwtToken');
    const agencyId = Cookies.get('agencyUUID');
    const enabled = Boolean(token && agencyId);

    const fuelKey = enabled ? ['vc-registry-fuel', token, agencyId] : null;
    const evKey = enabled ? ['vc-registry-ev', token, agencyId] : null;

    const {
        data: fuelData,
        error: fuelError,
        isValidating: fuelValidating,
    } = useSWR(fuelKey, fuelFetcher, { revalidateOnFocus: false });

    const {
        data: evData,
        error: evError,
        isValidating: evValidating,
    } = useSWR(evKey, evFetcher, { revalidateOnFocus: false });

    return useMemo(() => {
        const { options, priceByValue } = buildRegistryFuelTariffState(fuelData, evData);
        const validValues = new Set(options.map((option) => option.value));
        const loading = enabled && (
            (!fuelData && !fuelError && fuelValidating)
            || (!evData && !evError && evValidating)
        );

        return {
            fuelTariffOptions: options,
            priceByValue,
            validValues,
            loading,
            error: fuelError || evError,
        };
    }, [
        enabled,
        fuelData,
        evData,
        fuelError,
        evError,
        fuelValidating,
        evValidating,
    ]);
};
